/** A coarse clock for presentation (the card's age and local time): re-renders every `everyMs`. */

import { useEffect, useState } from 'react';

export function useNow(everyMs = 5_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), everyMs);
    return () => window.clearInterval(id);
  }, [everyMs]);
  return now;
}
